import { Index } from "components/FooterTexts/CookiePolicy/Index";
import React from "react";

const CookiePolicy = () => {
  return <Index />;
};

export default CookiePolicy;
